<div class="card">
  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <a
        class="nav-item nav-link"
        *ngIf="checkRoutePermission('/user-management/create-users')"
        id="nav-create-users-tab"
        [routerLink]="['/user-management/create-users/']"
        [routerLinkActive]="['active']"
        >Create Users</a
      >
      <a
        class="nav-item nav-link"
        *ngIf="checkRoutePermission('/user-management/manage-users')"
        id="nav-user-management-tab"
        [routerLink]="['/user-management/manage-users/']"
        [routerLinkActive]="['active']"
        >Manage Users</a
      >
      <a
        class="nav-item nav-link"
        *ngIf="checkRoutePermission('/user-management/manage-roles')"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/manage-roles/']"
        [routerLinkActive]="['active']"
        >Manage Roles</a
      >
      <a
        class="nav-item nav-link"
        *ngIf="checkRoutePermission('/user-management/manage-plan-type')"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/manage-plan-type/']"
        [routerLinkActive]="['active']"
        >Manage Plan Type</a
      >
      <a
        class="nav-item nav-link"
        *ngIf="checkRoutePermission('/user-management/manage-pub-type')"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/manage-pub-type/']"
        [routerLinkActive]="['active']"
        >Manage Publications</a
      >
      <a
        class="nav-item nav-link"
        *ngIf="checkRoutePermission('/user-management/audit-trails')"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/audit-trails/']"
        [routerLinkActive]="['active']"
        >Audit Trail
      </a>
      <a
        class="nav-item nav-link"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/impact-assessment-settings']"
        [routerLinkActive]="['active']"
        *ngIf="
          checkRoutePermission('/user-management/impact-assessment-settings')
        "
        >Configure Assessments</a
      >
      <a
        class="nav-item nav-link"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/rulebook-settings']"
        [routerLinkActive]="['active']"
        *ngIf="checkRoutePermission('/user-management/rulebook-settings')"
        >Rulebook Settings</a
      >
      <a
        class="nav-item nav-link"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/reporting-settings']"
        [routerLinkActive]="['active']"
        *ngIf="checkRoutePermission('/user-management/reporting-settings')"
        >Configure Reporting</a
      >
      <a
        class="nav-item nav-link"
        id="nav-manage-role-tab"
        [routerLink]="['/user-management/theme-settings']"
        [routerLinkActive]="['active']"
        *ngIf="checkRoutePermission('/user-management/theme-settings')"
        >Configure Theme</a
      >
      <a
        class="nav-item nav-link"
        id="nav-manage-role-tab"
        *ngIf="checkRoutePermission('/user-management/project-name')"
        [routerLink]="['/user-management/project-name']"
        [routerLinkActive]="['active']"
        >Configure Projects</a
      >
    </div>
  </nav>
  <div class="card-body p-3">
    <div class="tab-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
